import React, { useRef, useState } from 'react'
import compose from 'recompose/compose'
import { withI18n } from '../../hocs'
import CardEvaluativeTestsStyled from './styled'
import moment from 'moment'
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import { LinearProgress } from '@material-ui/core'
import { CalendarDays, Copy, FileSpreadsheet, ListChecks, MoreHorizontal, Pencil, Trash2 } from 'lucide-react'
import { InfoChip } from '../../atoms'
import { checkCsvCandidates } from '../../../api'
import CsvUploader from '../csv-uploader';
import { useAppContext } from '../../../context/appContext'
import { ModalImportEvaluativeTestsCandidates } from '../index'
import { tokens } from '../../../assets/tokens'

// Menú con el estilo de los desplegables de Velora: papel con radio 8, items de 40 px en 14/400 e
// iconos lucide de 16 px; «Eliminar» en el color de error
const useStyles = makeStyles(() => ({
  paper: {
    minWidth: 200,
    marginTop: 4,
    borderRadius: 8,
    boxShadow: tokens.shadow.card,
  },
  list: {
    padding: '4px 0',
  },
  item: {
    height: 40,
    margin: '2px 6px',
    padding: '0 12px',
    gap: 10,
    borderRadius: 6,
    fontFamily: tokens.typography.fontFamily.primary,
    fontSize: 14,
    fontWeight: 400,
    color: tokens.color.text.secondary,
    '& svg': {
      color: tokens.color.text.tertiary,
    },
    '&:hover': {
      backgroundColor: tokens.color.background.light,
    },
  },
  itemDanger: {
    color: tokens.color.error.main,
    '& svg': {
      color: tokens.color.error.main,
    },
  },
}));

const CardEvaluativeTests = ({ i18n, title, pretitle, rangeDate, quantityQuestions, onEdit, onDuplicate, onDelete, testId, statusCard, isInactive
}) => {

  const [uploadCsvInProgress, setUploadCsvInProgress] = useState(false);
  const [showSendNotificationModal, setShowSendNotificationModal] = useState(false);
  const [uploadResult, setUploadResult] = useState([]);
  const [currentForm, setCurrentForm] = useState(null);
  const csvUploaderTriggerRef = useRef(null);
  const {module} = useAppContext();

  const allowCsvUpload = true;

  const onAddCandidatesCsv = function(e) {
    if(csvUploaderTriggerRef.current) {
      csvUploaderTriggerRef.current();
    }
  }
  const setCsvUploaderTrigger = (trigger) => {
    csvUploaderTriggerRef.current = trigger;
  };
  const uploadCsv = function(form) {
    setCurrentForm(form);
    setUploadCsvInProgress(true);
    return checkCsvCandidates(testId, module, form);
  }

  const [anchorEl, setAnchorEl] = useState(null);
  const formattedRangeDate = rangeDate.split(' - ').map(date => moment(date).format('DD/MM/YYYY')).join(' - ');
  const classes = useStyles();

  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const uploadCsvFinished = function(result) {
    setUploadCsvInProgress(false);
    setShowSendNotificationModal(true);
    setUploadResult(result);

    handleCloseMenu();
  }

  return (
    <CardEvaluativeTestsStyled>
      {uploadCsvInProgress ? <LinearProgress /> : <></>}

      <div className="card-container">
        <div className="card-header">
          <div className="card-header-text">
            {pretitle && <span className="card-pretitle">{pretitle}</span>}
            <span className="card-title" title={title}>{title}</span>
          </div>
          <IconButton size="small" className="card-menu-button" onClick={handleClickMenu} aria-label="menu">
            <MoreHorizontal size={18} />
          </IconButton>
        </div>
        <Menu
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleCloseMenu}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          classes={{ paper: classes.paper, list: classes.list }}
        >
          <MenuItem className={classes.item} onClick={() => onEdit(testId)}>
            <Pencil size={16} />
            {i18n.evaluativeTests.menuEdit}
          </MenuItem>
          {allowCsvUpload &&
            <MenuItem className={classes.item} onClick={() => onAddCandidatesCsv(testId)}>
              <CsvUploader
                uploadFn={uploadCsv}
                callbackFn={uploadCsvFinished}
                triggerClick={setCsvUploaderTrigger}
                showAlert={false}
              />
              <FileSpreadsheet size={16} />
              {i18n.evaluativeTests.menuAddCsv}
            </MenuItem>
          }
          <MenuItem className={classes.item} onClick={() => {
            onDuplicate();
            handleCloseMenu();
          }}>
            <Copy size={16} />
            {i18n.evaluativeTests.menuDuplicate}
          </MenuItem>
          <MenuItem className={`${classes.item} ${classes.itemDanger}`} onClick={() => {
            onDelete();
            handleCloseMenu();
          }}>
            <Trash2 size={16} />
            {i18n.evaluativeTests.menuDelete}
          </MenuItem>
        </Menu>

        <div className="card-content">
          <CalendarDays size={16} className="card-icon" />
          <span className="card-text">{formattedRangeDate}</span>
        </div>
        <div className="card-content">
          <ListChecks size={16} className="card-icon" />
          <span className="card-text">{quantityQuestions}</span>
          {isInactive ? (
            <InfoChip label={statusCard} />
          ) : null}
        </div>
      </div>

      {showSendNotificationModal && <ModalImportEvaluativeTestsCandidates
        evaluativeConfigId={testId}
        form={currentForm}
        isModalOpen={showSendNotificationModal}
        handleClose={() => setShowSendNotificationModal(false)}
        uploadResult={uploadResult}/>}
    </CardEvaluativeTestsStyled>
  )
}

const enharce = compose(withI18n)

export default enharce(CardEvaluativeTests)
